exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag, .subtag {\n  padding: 0.3ex;\n  padding-left: 1ex;\n  padding-right: 1ex;\n  border: thin solid silver;\n  margin: 0.5ex;\n  border-radius: 8px;\n  font-weight: bold;\n  background-color: silver;\n  display: inline-block;\n  cursor: pointer\n}\n\n.tag.selected {\n  background-color: #BCEDAF;\n}\n\n.subtag {\n  font-size: small;\n}\n\n.subtag.selected {\n  background-color: lightsalmon;\n}\n\n.subtags {\n  margin-left:60px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/r-tag-group/r-tag-group.component.css
// module id = ../../../../../src/app/r-tag-group/r-tag-group.component.css
// module chunks = main